import {
    LISTAR_ESTATUSSOLICITUDCOMPRAS,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_ESTATUSSOLICITUDCOMPRAS:
            return{
                ...state, 
                estatusSolicitudCompra: action.payload
            }
        default:
            return state
    }
        
}